export default __webpack_public_path__ + "static/media/tax-returns-etf.8ca76d63.png";